"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorLocalizationByCode = void 0;
var _defaultTranslations = require("../constants/defaultTranslations");
var _TranslationKey = require("../models/TranslationKey");
const getErrorLocalizationByCode = (errorCode, fieldName) => {
  switch (errorCode) {
    case '105':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationRequired,
        id: _TranslationKey.TranslationKey.validationRequired
      };
    case '112':
      return {
        id: _TranslationKey.TranslationKey.sponsorChangeNotExistingSponsor,
        defaultMessage: _defaultTranslations.defaultTranslations.sponsorChangeNotExistingSponsor
      };
    case '113':
      return {
        id: _TranslationKey.TranslationKey.sponsorChangeBlockedSponsor,
        defaultMessage: _defaultTranslations.defaultTranslations.sponsorChangeBlockedSponsor
      };
    case '119':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationLength,
        id: _TranslationKey.TranslationKey.validationLength
      };
    case '106':
      switch (fieldName) {
        case 'contactEmail':
          return {
            defaultMessage: _defaultTranslations.defaultTranslations.validationRegexEmail,
            id: _TranslationKey.TranslationKey.validationRegexEmail
          };
        case 'contactTelephone':
          return {
            defaultMessage: _defaultTranslations.defaultTranslations.validationRegexPhone,
            id: _TranslationKey.TranslationKey.validationRegexPhone
          };
        case 'uniqueId':
          return {
            defaultMessage: _defaultTranslations.defaultTranslations.validationRegexUniqueID,
            id: _TranslationKey.TranslationKey.validationRegexUniqueID
          };
        case 'birthDate':
          return {
            defaultMessage: _defaultTranslations.defaultTranslations.validationRegexBirthDate,
            id: _TranslationKey.TranslationKey.validationRegexBirthDate
          };
        case 'identityCard.expiration':
          return {
            defaultMessage: _defaultTranslations.defaultTranslations.validationRegexIdentityCardDateExpiration,
            id: _TranslationKey.TranslationKey.validationRegexIdentityCardDateExpiration
          };
        default:
          return {
            defaultMessage: _defaultTranslations.defaultTranslations.validationRegex,
            id: _TranslationKey.TranslationKey.validationRegex
          };
      }
    case '108':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationEmailIsAlreadyUsed,
        id: _TranslationKey.TranslationKey.validationEmailIsAlreadyUsed
      };
    case '109':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniquePhone,
        id: _TranslationKey.TranslationKey.validationUniquePhone
      };
    case '110':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueUniqueId,
        id: _TranslationKey.TranslationKey.validationUniqueUniqueId
      };
    case '117':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationValidUniqueId,
        id: _TranslationKey.TranslationKey.validationValidUniqueId
      };
    case '121':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationEmailTerminatedCustomer,
        id: _TranslationKey.TranslationKey.validationEmailTerminatedCustomer
      };
    case '128':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueBankAccount,
        id: _TranslationKey.TranslationKey.validationUniqueBankAccount
      };
    case '134':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationXmlCharacters,
        id: _TranslationKey.TranslationKey.validationXmlCharacters
      };
    case '136':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationMaxSize,
        id: _TranslationKey.TranslationKey.validationMaxSize
      };
    case '137':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.fileTypeIsNotSupported,
        id: _TranslationKey.TranslationKey.fileTypeIsNotSupported
      };
    case '138':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationSingleFile,
        id: _TranslationKey.TranslationKey.validationSingleFile
      };
    case '139':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationValidConfirmationCode,
        id: _TranslationKey.TranslationKey.validationValidConfirmationCode
      };
    case '141':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationMandatoryPropertyIsNull,
        id: _TranslationKey.TranslationKey.validationMandatoryPropertyIsNull
      };
    case '149':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueCustomerAttribute,
        id: _TranslationKey.TranslationKey.validationUniqueCustomerAttribute
      };
    case '151':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueTaxCode,
        id: _TranslationKey.TranslationKey.validationUniqueTaxCode
      };
    case '152':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueTaxCode2,
        id: _TranslationKey.TranslationKey.validationUniqueTaxCode2
      };
    case '155':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueAlias,
        id: _TranslationKey.TranslationKey.validationUniqueAlias
      };
    case '156':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationUniqueDisplayName,
        id: _TranslationKey.TranslationKey.validationUniqueDisplayName
      };
    case '153':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationValidPhone,
        id: _TranslationKey.TranslationKey.validationValidPhone
      };
    case '244':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.birthDate_LegalRequirementsFailed,
        id: _TranslationKey.TranslationKey.birthDate_LegalRequirementsFailed
      };
    case '403':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.document_ExpirationTooSoon,
        id: _TranslationKey.TranslationKey.document_ExpirationTooSoon
      };
    case '111':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.birthDate_DoesntMatchUniqueId,
        id: _TranslationKey.TranslationKey.birthDate_DoesntMatchUniqueId
      };
    case '118':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.birthDate_OutOfRange,
        id: _TranslationKey.TranslationKey.birthDate_OutOfRange
      };
    case '148':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.termsAndConditions_Mandatory,
        id: _TranslationKey.TranslationKey.termsAndConditions_Mandatory
      };
    case '104':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.customer_NotUnique,
        id: _TranslationKey.TranslationKey.customer_NotUnique
      };
    case '169':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.customer_NotEligible,
        id: _TranslationKey.TranslationKey.customer_NotEligible
      };
    case '115':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationValidSponsorNumber,
        id: _TranslationKey.TranslationKey.validationValidSponsorNumber
      };
    case '179':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.Prestep_ExternalAccountAlreadyConnected,
        id: _TranslationKey.TranslationKey.Prestep_ExternalAccountAlreadyConnected
      };
    case '166':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.validationZipCodeStructure,
        id: _TranslationKey.TranslationKey.validationZipCodeStructure
      };
    case '299':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.Prestep_UnauthorizedAccess,
        id: _TranslationKey.TranslationKey.Prestep_UnauthorizedAccess
      };
    case '428':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.Prestep_InvitationCodeNotFound,
        id: _TranslationKey.TranslationKey.Prestep_InvitationCodeNotFound
      };
    case '324':
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.Prestep_RegistrationFailed,
        id: _TranslationKey.TranslationKey.Prestep_RegistrationFailed
      };
    default:
      return {
        defaultMessage: _defaultTranslations.defaultTranslations.errorOccured,
        id: _TranslationKey.TranslationKey.errorOccured
      };
  }
};
exports.getErrorLocalizationByCode = getErrorLocalizationByCode;
//# sourceMappingURL=getErrorLocalizationByCode.js.map